module.exports = __webpack_public_path__ + "static/media/no_retreat_120.5dc1f1d5.png";